import { configureStore } from '@reduxjs/toolkit';
import { reportingApi } from 'src/app/standaloneSlices/apiSlice';
import { AuthReducer } from 'src/app/standaloneSlices/tokenSlice';
import { ReportReducer } from 'src/feature/Menu/ReportSlice';
import { AgeingReducer } from '../feature/AgeingPeriod/AgeingPeriodSlice';
import { FilterReducer } from '../feature/Filters/FiltersSlice';
import { SnackBarReducer } from './SnackBarSlice';

export const store = configureStore({
  reducer: {
    filters: FilterReducer,
    report: ReportReducer,
    agedPeriod: AgeingReducer,
    snackBar: SnackBarReducer,
    auth: AuthReducer,
    [reportingApi.reducerPath]: reportingApi.reducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(reportingApi.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
